class CountdownClock extends HTMLElement {
  updateCountdown = () => {
    let time = parseInt(
      (this.expirationDate.getTime() - new Date().getTime()) / 1000,
      10
    );

    if (isNaN(time) || Object.is(time, -0) || time < 0) {
      clearInterval(this.intervalId);

      if (this.messageEl) this.messageEl.hidden = false;

      return;
    }

    const days = parseInt(time / 86400, 10);
    time %= 86400;

    const hours = parseInt(time / 3600, 10);
    time %= 3600;

    const minutes = parseInt(time / 60, 10);
    time %= 60;

    const seconds = parseInt(time, 10);

    if (this.daysEl) {
      if (this.hideDaysWhenZero && days <= 0) {
        this.daysEl.parentElement.remove();
      } else {
        this.daysEl.textContent = days;
      }
    }

    this.hoursEl.textContent = hours.toString().padStart(2, "0");
    this.minutesEl.textContent = minutes.toString().padStart(2, "0");
    this.secondsEl.textContent = seconds.toString().padStart(2, "0");
  };

  constructor() {
    super();

    const { expirationDate, hideDaysWhenZero } = this.dataset;

    this.intervalId = 0;
    this.daysEl = this.querySelector(".js-days");
    this.hoursEl = this.querySelector(".js-hours");
    this.minutesEl = this.querySelector(".js-minutes");
    this.secondsEl = this.querySelector(".js-seconds");
    this.messageEl = this.querySelector(".js-message");
    this.hideDaysWhenZero = hideDaysWhenZero === "true";
    this.expirationDate = expirationDate
      ? new Date(expirationDate)
      : new Date();

    this.setup();
  }

  setup() {
    this.updateCountdown();
    this.intervalId = setInterval(this.updateCountdown, 1000);
  }
}

if (!window.customElements.get("countdown-clock")) {
  window.customElements.define("countdown-clock", CountdownClock);
}
